import { render, staticRenderFns } from "./ReviewDVIR.vue?vue&type=template&id=2175618b&scoped=true&"
import script from "./ReviewDVIR.vue?vue&type=script&lang=js&"
export * from "./ReviewDVIR.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDVIR.vue?vue&type=style&index=0&id=2175618b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175618b",
  null
  
)

export default component.exports